package br.com.texeratx.boardgametimeapp.domain.usecases.player

import br.com.texeratx.boardgametimeapp.data.model.player.UpdatePlayerRequest
import br.com.texeratx.boardgametimeapp.data.repository.PlayerRepository

class UpdatePlayerUseCase(
    private val repository: PlayerRepository
) {
    suspend operator fun invoke(
        playerId: Long,
        request: UpdatePlayerRequest
    ): Result<Unit> {
        return repository.updatePlayer(playerId, request)
    }
}
